import type { SVGProps } from 'react'
const SvgMECResend = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="20"
    viewBox="0 0 15 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.74967 13.3757C1.44412 12.8479 1.21495 12.3062 1.06217 11.7507C0.909397 11.1951 0.833008 10.6257 0.833008 10.0423C0.833008 8.18121 1.47884 6.59787 2.77051 5.29232C4.06217 3.98676 5.63856 3.33398 7.49967 3.33398H7.64551L6.31217 2.00065L7.47884 0.833984L10.8122 4.16732L7.47884 7.50065L6.31217 6.33398L7.64551 5.00065H7.49967C6.11079 5.00065 4.93023 5.49023 3.95801 6.4694C2.98579 7.44857 2.49967 8.63954 2.49967 10.0423C2.49967 10.4034 2.54134 10.7576 2.62467 11.1048C2.70801 11.452 2.83301 11.7923 2.99967 12.1257L1.74967 13.3757ZM7.52051 19.1673L4.18717 15.834L7.52051 12.5007L8.68717 13.6673L7.35384 15.0007H7.49967C8.88856 15.0007 10.0691 14.5111 11.0413 13.5319C12.0136 12.5527 12.4997 11.3618 12.4997 9.95898C12.4997 9.59787 12.458 9.24371 12.3747 8.89649C12.2913 8.54926 12.1663 8.20898 11.9997 7.87565L13.2497 6.62565C13.5552 7.15343 13.7844 7.6951 13.9372 8.25065C14.09 8.80621 14.1663 9.37565 14.1663 9.95898C14.1663 11.8201 13.5205 13.4034 12.2288 14.709C10.9372 16.0145 9.36079 16.6673 7.49967 16.6673H7.35384L8.68717 18.0007L7.52051 19.1673Z"
      fill="#5E5E5E"
    />
  </svg>
)
export default SvgMECResend
